// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_al-0";
export var orangeButton = "_al-1";